// extracted by mini-css-extract-plugin
export default {"link_left":"list-item_link_left__oc2Zk","title":"list-item_title__Xe3ST"};